module.exports = __webpack_public_path__ + "img/zhihuijiaotong.28897454.png";